<template>
	<div class="contractPreview">
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
			<span v-if="this.$route.query.type == 1">预审租赁合同</span>
			<span v-if="this.$route.query.type == 2">正式租赁合同</span>
			<div v-if="this.$route.query.type == 1" style="font-size: 0.75rem;" @click="decontract">删除</div>
			<div v-else style="font-size: 0.75rem;"></div>

		</div>
		<div style="width: 100%; margin-top: 2.8125rem;">
			<pdf ref="pdf" v-for="i in numPages" :key="i" :src="url" :page="i"></pdf>
		</div>
		<div style="height: 2.5rem;"></div>
		<div class="osc">
			<div class="bottom">
				<div @click="download">下载</div>
			</div>
		</div>
	</div>
</template>

<script>
	import pdf from 'vue-pdf';

	export default {
		components: {
			pdf
		},
		data() {
			return {
				url: 'https://backstage.jbj-china.com.cn/mobile/order/topdf?order_number=' + this.$route.query.order_number +
					'&type=' + this.$route.query.type,
				numPages: null, // pdf 总页数
			}
		},
		created() {
			if (this.$route.query.way == 1) {
				this.url = 'https://backstage.jbj-china.com.cn/mobile/order/topdf?order_number=' + this.$route.query.order_number +
					'&type=' + this.$route.query.type + '&way=1'
			}
		},
		mounted() {
			this.getNumPages()
		},
		methods: {
			// 下载
			download() {
				BSL.OpenWeb(this.url)
			},
			// 预览
			getNumPages() {
				this.$toast.loading({
					message: '合同加载中...',
					forbidClick: true,
					duration: 5000,
					overlay: true,
				});
				let loadingTask = pdf.createLoadingTask(this.url)
				loadingTask.promise.then(pdf => {
					this.numPages = pdf.numPages
				}).catch(err => {
					console.error('pdf 加载失败', err);
				})
			},
			// 删除
			decontract() {
				this.$dialog.confirm({
						title: '温馨提示',
						message: '您确定要删除此预审合同吗？',
					})
					.then(() => {
						this.$axios.post(baseUrl + '/mobile/order/contractDel', {
							token: localStorage.getItem('Authorization'),
							id: this.$route.query.id
						}).then((res) => {
							if (res.data.code == 1) {
								this.$toast("删除成功");
								this.$router.push({
									path: '/mycontract',
								})
							}
						}).catch((err) => {
							console.log(err);
						});
					})
					.catch(() => {
						// on cancel
					});
			}
		}
	}
</script>

<style>
	.contractPreview .osc {
		width: 100%;
		position: fixed;
		bottom: 0;
		background-color: #fff;
		padding: 0.5rem 0;
	}

	.contractPreview .bottom {
		width: 80%;
		height: 2rem;
		line-height: 2rem;
		margin: auto;
		font-size: 16px;

	}

	.contractPreview .bottom>div {
		background-color: #F1452F;
		border-radius: 999px;
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/contractPreview/contractPreview.vue